import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import React from 'react';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import { useSIPControl } from 'features/toolbar/toolbar/controls/sip/useSIPControl';
import { SIPConnectedBadgeColor } from 'features/sip/constants';

const SIPControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const { icon, isFeatureAvailable, toggleConnectionModal, label, status } = useSIPControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    toggleConnectionModal();
  };

  return (
    <MobileMenuItem
      icon={icon}
      onClick={handleClick}
      badgeActive
      BadgeProps={{
        invisible: status !== 'connected',
        variant: 'dot',
        color: SIPConnectedBadgeColor as any,
      }}
    >
      {label}
    </MobileMenuItem>
  );
};

export default SIPControlMobile;
